<div class="auth-title-text">
  {{ viewModel.authFlowTitle$ | async }}
</div>

<div class="auth-flow-subtext">
  <div class="subtext" i18n>
    A 6-Digit Code has been sent to {{ userEmail$ | async }}. Please allow 5-10 minutes for this message to arrive. If
    you don’t see an email from us, you may need to check your spam folder.
  </div>
  <div class="subtext mt-3" i18n>
    Enter your code below to verify your email address and finalize your account creation.
  </div>
</div>

<form [formGroup]="formGroup" class="d-flex flex-column gap-4 mb-4">
  <div class="d-flex flex-column gap-2">
    <label for="verificationCode" class="form-input-label" i18n>Verification Code</label>
    <app-text-input
      formControlName="code"
      controlId="verificationCode"
      (keydown.enter)="submit()"
      [error]="formSubmitted && formGroup.controls.code.invalid" />
    <app-form-error
      *ngIf="formSubmitted && formGroup.controls.code.invalid"
      [errors]="formGroup.controls.code.errors" />
  </div>
</form>

<div class="d-flex gap-2 align-items-baseline mb-4 subtext">
  <ng-container i18n>Didn’t get a code?</ng-container>
  <button class="paddingless-text-button support-text" (click)="resendCode()">
    <ng-container i18n>Resend verification code</ng-container>
  </button>
</div>

<div class="action-button-container">
  <app-primary-button [style.width.%]="100" [width]="'100%'" (buttonClicked)="submit()">
    <ng-container i18n>Verify Account</ng-container>
  </app-primary-button>
</div>
<div class="member-support-button-container">
  <ng-container i18n>Having trouble?</ng-container>
  <button class="paddingless-text-button support-text mt-2" (click)="viewModel.openContactPage()">
    <ng-container i18n>Click here for support</ng-container>
  </button>
</div>
